import { render, staticRenderFns } from "./M4.vue?vue&type=template&id=ed664a28&scoped=true"
import script from "./M4.vue?vue&type=script&lang=js"
export * from "./M4.vue?vue&type=script&lang=js"
import style0 from "./M4.vue?vue&type=style&index=0&id=ed664a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed664a28",
  null
  
)

export default component.exports